import React from "react";
import {
    ProductSerializer,
    ProductCardSerializer,
    ProductImageGallerySerializer,
} from "web/types/serializers";
import ProductGallery from "web/react/components/product-gallery/product-gallery";

interface PDPGalleryProps {
    product: ProductSerializer | ProductImageGallerySerializer;
    features: { [key: string]: any };
    relatedProducts?: ProductCardSerializer[];
    hasRelatedProductsSidebar: boolean;
    variant?: "oos-carousel";
    analyticsAction?: string;
}

function PDPGallery({
    features,
    product,
    relatedProducts,
    hasRelatedProductsSidebar,
    analyticsAction,
    variant,
}: PDPGalleryProps): React.ReactElement {
    let isSwipeOnRedirect = features?.pmt_221_swipe_redirect && product?.images.length >= 3;

    return (
        <ProductGallery
            analyticsAction={analyticsAction}
            relatedProducts={relatedProducts}
            images={product.images}
            currentLinkId={(product as ProductSerializer)?.link_ids?.[0] || undefined}
            swipeRedirect={isSwipeOnRedirect}
            hasRelatedProductsSidebar={hasRelatedProductsSidebar}
            variant={variant}
        />
    );
}

export default PDPGallery;
